import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaPrompt } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaPrompt";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";
import { useEffect } from "react";
import { RotatingAllenKey } from "../RotatingAllenKey/RotatingAllenKey";
import ModalColumn from "../ModalColumn/ModalColumn";

type SomethingWentWrongPromptProps = {
  onRefreshClick: () => void;
};

function SomethingWentWrongPrompt({
  onRefreshClick,
}: SomethingWentWrongPromptProps) {
  const { t } = useTranslation();

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    document.addEventListener("keydown", handleEscape, true);

    return () => {
      document.removeEventListener("keydown", handleEscape, true);
    };
  }, []);

  return (
    <FixaModal visible={true} handleCloseBtn={() => {}}>
      <FixaPrompt
        title=""
        titleId=""
        header={null}
        footer={
          <FixaModalFooter>
            <FixaButton
              text={t("refreshString")}
              onClick={onRefreshClick}
              type="primary"
            />
          </FixaModalFooter>
        }
      >
        <ModalColumn gap="medium">
          <RotatingAllenKey />
          <FixaText textStyle="Heading.M" tagName="h2">
            {t("sorrySomethingWentWrongString")}
          </FixaText>
          <FixaText textStyle="Body.M">
            {t("pleaseRefreshApplicationString")}
          </FixaText>
        </ModalColumn>
      </FixaPrompt>
    </FixaModal>
  );
}

export default SomethingWentWrongPrompt;
